import { REFERRAL_CONFIG, SUBSCRIPTION_STATUS } from '../constants/referrals.constants';

/**
 * Get subscription status label from status value
 */
export function getSubscriptionStatusLabel(status: number): string {
    return status === SUBSCRIPTION_STATUS.ACTIVE ? 'Active' : 'Inactive';
}

/**
 * Generate referral URL for a given username
 */
export function generateReferralUrl(username: string, isProduction: boolean = false): string {
    const baseUrl = isProduction ? REFERRAL_CONFIG.BASE_URL.PRODUCTION : REFERRAL_CONFIG.BASE_URL.STAGING;
    return `${baseUrl}/${username}`;
}

/**
 * Calculate monthly earnings based on number of creators
 */
export function calculateMonthlyEarnings(creatorsCount: number, ratePerCreator: number = 6): number {
    return creatorsCount * ratePerCreator;
}

/**
 * Calculate yearly earnings
 */
export function calculateYearlyEarnings(monthlyEarnings: number): number {
    return monthlyEarnings * 12;
}

/**
 * Generate chart bars data for earnings visualization
 */
export function generateChartBars(count: number = 8) {
    return Array.from({ length: count }, (_, index) => {
        const opacity = (index + 1) / count; // 0.125 to 1.0 opacity
        const height = ((index + 1) / count) * 100; // 12.5% to 100% height
        return {
            id: index + 1,
            opacity,
            height,
        };
    });
}
